import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
// eslint-disable-next-line import/no-useless-path-segments
import WorkingProcessForm from './../../../components/Forms/WorkingProcess/WorkingProcessForm';

const WorkingProcess = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('working-process'));

    const columns = [
        {
            name: 'Serial',
            wrap: true,
            center: 'true',
            selector: (row) => row?.serial,
        },
        {
            name: 'Name',
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Icon Class',
            wrap: true,
            center: 'true',
            selector: (row) => <i className={row?.icon_class} style={{ fontSize: '30px' }} />,
        },
        {
            name: 'Description',
            wrap: true,
            center: 'true',
            selector: (row) => row?.description,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewWhyChooseUsHandler = (formValue) =>
        request.create('working-process', formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    // update

    const updateWhyChooseUsHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formValue;

        return request.updateOne('working-process', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteWhyChooseUsHandler = () =>
        request.delete('working-process', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Working Process'
            buttonTitle='Add New Process'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Process'
                    size='lg'
                >
                    <WorkingProcessForm apiHandler={createNewWhyChooseUsHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Process'
                    size='lg'
                >
                    <WorkingProcessForm
                        apiHandler={updateWhyChooseUsHandler}
                        editData={selectedItem}
                    />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteWhyChooseUsHandler}
                />
            )}
        </CardLayout>
    );
};

export default WorkingProcess;
